<p *ngIf="loading" class="br-text-muted" role="status">Loading campaign charts...</p>
<p *ngIf="!loading && !workflow" class="br-text-muted" role="status">Campaign charts are unavailable. Retry progress to load saved data.</p>
<div *ngIf="!loading && workflow" class="campaign-chart-grid">
  <section *ngIf="step === '3'" class="br-card br-p-3">
    <div class="br-flex br-justify-between br-items-center br-gap-2 br-mb-2">
      <h3 class="br-section-title br-m-0" title="Ready means an assignee, next action and due date are saved.">Action readiness</h3>
      <strong>{{ workflow.arrangedCount }} / {{ workflow.targetCount }}</strong>
    </div>
    <div *ngIf="workflow.targetCount; else noLeads" class="campaign-chart-frame">
      <canvas baseChart type="doughnut" [data]="readiness" [options]="donutOptions" role="img"
              [attr.aria-label]="'Action readiness. ' + readinessSummary"></canvas>
      <div class="campaign-chart-center" aria-hidden="true"><strong>{{ readinessPercent }}%</strong><span class="br-text-muted">ready</span></div>
    </div>
  </section>
  <section class="br-card br-p-3">
    <div class="br-flex br-justify-between br-items-center br-gap-2 br-mb-2">
      <h3 class="br-section-title br-m-0" [attr.title]="caption">{{ title }}</h3>
      <span *ngIf="available" class="br-text-muted">{{ chartTotal }} Leads</span>
    </div>
    <ng-container *ngIf="available; else unavailable">
      <div *ngIf="chartTotal; else noLeads" class="campaign-chart-frame">
        <canvas baseChart type="bar" [data]="distribution" [options]="barOptions" role="img" [attr.aria-label]="title + '. ' + accessibleSummary"></canvas>
      </div>
    </ng-container>
    <p *ngIf="workflow.unavailableCount" class="br-text-muted br-mt-1 br-mb-0">{{ workflow.unavailableCount }} unavailable Leads are excluded from this breakdown.</p>
  </section>
</div>
<ng-template #noLeads><div class="campaign-chart-empty br-text-muted">{{ step === '4' ? 'No open Lead follow-ups to chart.' : 'No Leads to chart yet.' }}</div></ng-template>
<ng-template #unavailable><div class="campaign-chart-empty br-text-muted">This breakdown is not available yet.</div></ng-template>
